<template>
    <div class="echoEffectWrapper">
      
        <div class="sliderWrapper">
            <div class="d-flex align-items-center justify-content-center">
                <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    OFFSET
                </label>
                <div class="flex-1">
                    <input type="range" @input="setOffset" :value="offset" min="1" max="100" class="form-control-range" />
                </div>
                <div class="w-8 text-sm font-bold text-right text-gray-700 ml-2">{{offset}}</div>
            </div>
        </div>
        <div class="sliderWrapper mt-2">
            <div class="d-flex align-items-center justify-content-center">
                <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    DIRECTION
                </label>
                <div class="flex-1">
                    <input type="range" @input="setDirection" :value="direction" min="-180" max="180" class="form-control-range" />
                </div>
                <div class="w-8 text-sm font-bold text-right text-gray-700 ml-2">{{direction}}</div>
            </div>
        </div>
       
       
        <div class="colorWrapper mt-2">
            <div class="d-flex align-items-center justify-content-between">
                <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    COLOR
                </label>
                <verte @input="setColor" v-model="color" picker="square" menuPosition="top" model="rgb"></verte>
            </div> 
        </div>

    </div>
</template>

<script>
import verte from 'verte';
import 'verte/dist/verte.css';
export default {
    name:"EchoEffect",
    components: { verte },
    data(){
        return{
            color:"#000",
            offset:"50",
            direction:"-45",
        }
    },
    computed:{
        getObjProperties(){
            return this.$store.getters.getActiveObjectprops
        },
       
    },
    watch:{
        getObjProperties :{
          handler(updatedValues) {
            
            this.color = updatedValues.effectType.color;
            this.offset = updatedValues.effectType.offset;
            this.direction = updatedValues.effectType.direction;
         
                
            },
            deep: true,
            immediate: true
        }
    },
    methods:{
        setColor(e){
            
            this.color = e;
            this.$store.dispatch("setCurrentObjectProperties" , { effectType: this.createEcho() });

        },
        setOffset(e){
            
            this.offset = e.target.value;
            this.$store.dispatch("setCurrentObjectProperties" , { effectType: this.createEcho() });

        },
        setDirection(e){
            
            this.direction = e.target.value;
            this.$store.dispatch("setCurrentObjectProperties" , { effectType: this.createEcho() });

        },
        createEcho(){
            
            let obj = {
              type:"echo",
              color:this.color,
              offset:this.offset,
              direction:this.direction,
            };
  
              return obj
        }
    
    }
}
</script>
<style scoped>
.colorWrapper{
    padding: 0 19px;
}
</style>